import { themeGet } from '@styled-system/theme-get';
import { Box, Flex, Image, Link, Relative, Text } from 'pcln-design-system';
import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
const DRAG_THRESHOLD_PX = 10;
const StyledImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "HeroItem__StyledImage",
  componentId: "sc-6ubv7g-0"
})(["position:relative;object-fit:cover;&:hover{box-shadow:", ";}"], themeGet('shadows.xl'));
const StyledLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "HeroItem__StyledLink",
  componentId: "sc-6ubv7g-1"
})(["&:hover{cursor:pointer;}"]);
const AdHightlight = /*#__PURE__*/styled(Box).withConfig({
  displayName: "HeroItem__AdHightlight",
  componentId: "sc-6ubv7g-2"
})(["position:absolute;right:20px;top:20px;"]);
const GradientOverlay = /*#__PURE__*/styled.div.withConfig({
  displayName: "HeroItem__GradientOverlay",
  componentId: "sc-6ubv7g-3"
})(["position:absolute;inset:0;border-radius:", ";pointer-events:none;&:after{content:'';position:absolute;border-radius:", ";inset:0;background:", " transition:", ";}}"], themeGet('borderRadii.lg'), themeGet('borderRadii.lg'), ({
  isOverlay
}) => isOverlay ? 'linear-gradient(180deg, rgba(0, 0, 0, 0) 45.97%, rgba(0, 0, 0, 0.5) 62.18%, rgba(0, 0, 0, 0.7) 78.39%);' : '', ({
  isOverlay
}) => isOverlay ? 'background 0.2s ease-in-out' : '');
const ItemContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "HeroItem__ItemContainer",
  componentId: "sc-6ubv7g-4"
})(["position:relative;&:hover ", ":after{background:", ";}"], GradientOverlay, ({
  isOverlay
}) => isOverlay ? 'linear-gradient(180deg, rgba(0, 0, 0, 0) 45.97%, rgba(0, 0, 0, 0.5) 62.18%, rgba(0, 0, 0, 0.7) 78.39%)' : 'linear-gradient(180deg, rgba(0, 0, 0, 0) 45.97%, rgba(0, 0, 0, 0.4) 62.18%, rgba(0, 0, 0, 0.6) 78.39%)');
const ItemImageTextWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "HeroItem__ItemImageTextWrapper",
  componentId: "sc-6ubv7g-5"
})(["position:absolute;bottom:0%;gap:4px;"]);
const ItemRelative = /*#__PURE__*/styled(Relative).withConfig({
  displayName: "HeroItem__ItemRelative",
  componentId: "sc-6ubv7g-6"
})([""]);
export default function HeroItem({
  imageSrc,
  alt,
  heading,
  paragraph,
  href,
  onClick,
  overlayText,
  showAdHighlight = false
}) {
  const mouseStartX = useRef(0);
  const handleMouseDown = useCallback(e => {
    mouseStartX.current = e.screenX;
  }, []);
  const handleMouseMove = useCallback(e => {
    if (Math.abs(e.screenX - mouseStartX.current) <= DRAG_THRESHOLD_PX) {
      e.stopPropagation();
    }
  }, []);
  return React.createElement(StyledLink, {
    href: href,
    target: '_blank',
    tabIndex: -1,
    onClick: onClick,
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove
  }, React.createElement(ItemContainer, {
    borderRadius: 'lg',
    isOverlay: !!overlayText
  }, React.createElement(Flex, {
    key: heading,
    flexDirection: 'column'
  }, React.createElement(ItemRelative, {
    width: ['auto', '187px']
  }, React.createElement(StyledImage, {
    alt: alt,
    width: 187,
    height: 160,
    src: imageSrc,
    borderRadius: 'lg',
    loading: 'lazy'
  }), React.createElement(GradientOverlay, {
    isOverlay: !!overlayText
  }), React.createElement(ItemImageTextWrapper, {
    width: 'fit-content',
    flexDirection: 'column',
    p: 2
  }, React.createElement(Flex, {
    alignItems: 'left'
  }, React.createElement(Text, {
    textStyle: 'paragraphBold',
    color: 'text.lightest'
  }, overlayText)))), showAdHighlight && React.createElement(AdHightlight, {
    width: 19,
    height: 16,
    bg: 'background',
    borderRadius: 'xsm'
  }, React.createElement(Text, {
    textStyle: 'disclaimer',
    textAlign: 'center',
    color: 'text'
  }, "Ad")), React.createElement(Flex, {
    maxWidth: 187,
    flexDirection: 'column',
    style: {
      gap: '4px'
    },
    mt: 3,
    pl: 1
  }, React.createElement(Text, {
    textStyle: 'heading6',
    color: 'text'
  }, heading), React.createElement(Text, {
    textStyle: 'paragraph',
    color: 'text',
    textWrap: 'wrap'
  }, paragraph)))));
}